import { MailOutlined } from '@ant-design/icons/lib/icons'
import { Row } from 'antd'
import { MemberProps } from 'app/components/Core/convention'
import KCheckbox from 'app/components/Modules/Form/KCheckbox'
import KForm from 'app/components/Modules/Form/KForm'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import { KFormProps, RecordType } from 'app/constants/GlobalTypes'
import { ToolBox } from 'app/lib/hooks/toolBox'
import { useCurrentCustomer } from 'app/lib/hooks/useCurrent'
import * as React from 'react'

const Form: React.FC<MemberProps<IPayment, KFormProps<IPayment>>> = ({
  member,
  props: { onSuccess, portalId = 'payment-submit' },
  ...other
}) => {
  const { tAttribute } = ToolBox.useString()
  const { organization, billing_address } = useCurrentCustomer()

  return (
    <KForm
      portalId={portalId}
      initialFetch={false}
      silentSuccess={true}
      onSuccess={onSuccess}
      initialValues={member}
      recordType={RecordType.invoice_payment}
      layout="vertical">
      <Row gutter={[0, 24]}>
        <KCol span={24}>
          <Row>
            <KCol span={2}>
              <MailOutlined className="text-xl" />
            </KCol>
            <KCol span={22}>
              <Row gutter={[0, 4]}>
                <KCol span={24}>
                  <span className="text-primary mb-3">
                    {tAttribute({
                      recordType: RecordType.invoice_payment,
                      attribute: 'payment_address'
                    })}{' '}
                  </span>
                </KCol>
                <KCol span={24} render={Boolean(organization)}>
                  {organization}
                </KCol>
                <KCol span={24} render={Boolean(billing_address.recipient_name)}>
                  {billing_address.recipient_name}
                </KCol>
                <KCol span={24}>
                  {billing_address.address}{' '}
                  {billing_address.address2 ? billing_address.address2 : ''}
                </KCol>
                <KCol span={24}>
                  {billing_address.zip} {billing_address.city}
                </KCol>
              </Row>
            </KCol>
          </Row>
        </KCol>
        <KCol span={24} />
        <KCol span={24}>{other.children}</KCol>
        <KCol span={24}>
          <KCheckbox required hasFeedback={false} name="agb" />
        </KCol>
      </Row>
    </KForm>
  )
}

export default Form
